import MenuItem from './MenuItem';

import { ReactComponent as PerformanceIcon } from '../../icons/performance.svg';
import { ReactComponent as SearchIcon } from '../../icons/magnifyglass.svg';
import { ReactComponent as PlaylistIcon } from '../../icons/playlist.svg';
import { useContext } from 'react';
import { OrganisationContext } from '../../App';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';

export default function Menu({ open }) {
  const { selectedOrganisationObject } = useContext(OrganisationContext);
  const orgtype = selectedOrganisationObject?.orgtype || [];
  return (
    <>
      <MenuItem open={open} path="/" end label="Dashboard">
        <PerformanceIcon />
      </MenuItem>
      <MenuItem open={open} path={`/playlist`} label="Playlists">
        <PlaylistIcon />
      </MenuItem>
      <MenuItem open={open} path="/video-library" label="Video Library">
        <PlaylistIcon />
      </MenuItem>
      { orgtype.includes('rightsholder') && <MenuItem open={open} path="/pixels-studio" label="Pixels Studio">
        <MovieFilterIcon />
      </MenuItem>}
      <MenuItem open={open} path="/headline-search" label="Headline Search">
        <SearchIcon />
      </MenuItem>
    </>
  );
}

export function DefaultSection() {
  return '/';
}
